import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import SearchSelect from '../../../../components/Inputs/SearchSelect'
import {State} from '../../../../reducers'
import {cargarDistritosDelCliente} from '../../../../actions/catalogos.actions'
import {esNormativaV2} from '../../../../utils/normativa.utils'

interface PropiedadesDistritoClienteEncontrado {
  departamento: any
  municipio: any
  distrito: any
}

export default function DistritoClienteEncontrado({
  departamento,
  municipio,
  distrito,
}: PropiedadesDistritoClienteEncontrado) {
  const dispatch = useDispatch()
  const {distritos, datosEmisor} = useSelector((state: State) => state.catalogos)
  const normativaV2 = esNormativaV2(datosEmisor)

  const codigoDepartamento = `${departamento ?? ''}`.trim()
  const codigoMunicipio = `${municipio ?? ''}`.trim()
  const codigoDistrito = `${distrito ?? ''}`.trim()

  useEffect(() => {
    if (!normativaV2 || !codigoDepartamento) return
    dispatch(cargarDistritosDelCliente(codigoDepartamento, codigoMunicipio) as any)
  }, [normativaV2, codigoDepartamento, codigoMunicipio, dispatch])

  if (!normativaV2) return null

  return (
    <div className='w-layout-hflex h-inputs'>
      <div className='label-input'>
        <label htmlFor='distrito' className='field-label m'>
          Distrito
        </label>
        <SearchSelect
          defaultValue={null}
          disabled={true}
          placeholder={codigoDistrito ? 'Distrito' : 'Sin distrito registrado'}
          value={codigoDistrito}
          name='distrito'
          data={distritos}
          keyNameText='valor'
          keyNameValue='codigo'
          onChange={(value: any) => {}}
        />
        {!codigoDistrito && (
          <p className='alert s'>
            Este cliente no tiene distrito registrado. Al confirmar deberá seleccionarlo en el
            formulario para poder emitir.
          </p>
        )}
      </div>
      <div className='label-input'></div>
    </div>
  )
}
